import {
  faCamera,
  faFaceSmile,
  faPaperPlane,
  faSpinner,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BASE_PATH } from "api/commonApi";
import { usePostContentsMutation } from "api/popPageCommentsApi";
import Emoji from "components/community/common/Emoji";
import { contentsCheck } from "components/community/common/popPageCommonFunc/CommonFunc";
import { useLoginCheck } from "hooks/useLoginCheck";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  contentsValueState,
  isOpenEmojiState,
  isProfilePageState,
  popContValueState
} from "recoil/contentsAtom";
import {
  headersState,
  isLoginStateSelector,
  userProfileImgState,
  userProfileKeyState
} from "recoil/userInfoAtom";
import { ReplaceInput } from "styles/ReplaceInput";
import {
  emptyContentCheckTKey,
  imgsSizeTkey,
  imgsTypeTkey,
  imgsLenTkey
} from "utils/CommonTranslationKey";
import { deletetag } from "utils/DeleteTag";

interface IProps {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  idx: number;
  postNum: number;
}

function WriteLastComment(postProps: IProps) {
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const [popContValue, setPopContValue] = useRecoilState(popContValueState);
  const [contentsValue, setContentsValue] = useRecoilState(contentsValueState);
  const [emojiToggle, setEmojiToggle] = useState({});
  const setIsOpenEmoji = useSetRecoilState(isOpenEmojiState);
  const [imgBase64, setImgBase64] = useState<string>("");
  const [imgFile, setImgFile] = useState<FileList | null>(null);
  const userProfileKey = useRecoilValue(userProfileKeyState);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const isNotLogin = useLoginCheck();
  const headers = useRecoilValue(headersState);
  const userProfileImg = useRecoilValue(userProfileImgState);

  const onClickEmojiToggle = (idx: number) => {
    setEmojiToggle({
      [idx]: ![idx]
    });

    setIsOpenEmoji((prev) => !prev);
  };

  const onValueChange = (e: React.ChangeEvent<HTMLDivElement>) => {
    setPopContValue({ ...popContValue, content: e.target.innerHTML });
  };

  const handleAddImgComments = (e: React.ChangeEvent<HTMLInputElement>) => {
    let uploadFile: FileList | null = e.target.files;
    setImgFile(uploadFile);
    setImgBase64("");

    let file = e.target.files!;
    if (file[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(file[0]);
      reader.onloadend = () => {
        const base64 = reader.result;
        if (base64) {
          let base64Sub = base64.toString();
          setImgBase64(base64Sub);
        }
      };
    }
  };

  const closeImgBtn = () => {
    setImgFile(null);
    setImgBase64("");
  };

  const contentsCheckProps = {
    imgFile,
    imgsSizeTkey,
    imgsTypeTkey,
    imgsLenTkey,
    t
  };

  const { mutate: postMutate } = usePostContentsMutation(
    isProfilePage ? "profile_comments_board_list" : "comments_board_list"
  );

  const postApi = `${BASE_PATH}/${
    isProfilePage
      ? `api/vfunlounge/profile/post/comment`
      : `api/vfunlounge/comments/${postProps.postNum}`
  }`;

  let postValue: any = {};

  const contentsSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isLoginState.isLogIn) {
      isNotLogin();
      return;
    }

    if (popContValue.content === "") {
      alert(t(emptyContentCheckTKey));
      return;
    }

    const formData = new FormData();
    if (imgFile !== null && imgFile !== undefined && imgFile.length !== 0) {
      // 댓글과 사진
      if (contentsCheck(contentsCheckProps)) {
        Object.values(imgFile).forEach((file: any) =>
          formData.append("images[]", file)
        );
      }
    }

    formData.append("comment_idx", "0");
    formData.append("comment", popContValue.content);
    if (isProfilePage) {
      formData.append("user_profile_key", userProfileKey);
      formData.append("board_idx", postProps.postNum.toString() || "0");
    }
    postValue = formData;

    postProps.setIsLoading(true);

    const props = { postApi, postValue, headers };

    postMutate(props, {
      onSuccess: (api) => {
        if (api.data.result === 1) {
          setPopContValue({ ...popContValue, content: "" });
          setContentsValue("");

          setImgBase64("");
          setImgFile(null);
        }
        postProps.setIsLoading(false);
      },
      onError: (error: any) => {
        alert(t(error.response.data.message));
        postProps.setIsLoading(false);
      }
    });

    if (e.currentTarget.children[1] !== undefined) {
      e.currentTarget.children[1].innerHTML = "";
    }
    e.currentTarget.children[0].children[1].children[0].innerHTML = "";
  };

  useEffect(() => {
    setContentsValue("");
    setImgFile(null);
    setImgBase64("");
  }, [postProps.postNum]);

  return (
    <form onSubmit={contentsSubmit}>
      <div className="commentWrap">
        <img
          className="user-pic"
          src={
            userProfileImg.length !== 0
              ? userProfileImg
              : "//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
          }
          alt="로그인 전- 아이콘"
        />
        <div className="feed-input">
          <ReplaceInput
            onInput={onValueChange}
            className="txt"
            contentEditable="true"
            placeholder={t("Please_leave_a_reply")}
            dangerouslySetInnerHTML={{
              __html: deletetag(
                postProps.idx === postProps.postNum ? contentsValue : "",
                ["img", "br"]
              ) as string
            }}
          />

          <div className="btns">
            <div>
              <label htmlFor="img_file">
                <FontAwesomeIcon icon={faCamera} />
              </label>

              {postProps.idx === postProps.postNum && (
                <input
                  type="file"
                  accept=".gif, .jpg, .png"
                  id="img_file"
                  onChange={handleAddImgComments}
                  multiple={false}
                  data-idx={postProps.idx}
                />
              )}
            </div>

            {Object.keys(emojiToggle).includes(String(postProps.postNum)) ? (
              <Emoji />
            ) : null}

            <div onClick={() => onClickEmojiToggle(postProps.idx)}>
              <FontAwesomeIcon icon={faFaceSmile} />
            </div>
            <div>
              <button>
                {postProps.isLoading && postProps.idx === postProps.postNum ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  <FontAwesomeIcon icon={faPaperPlane} />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {imgBase64 !== "" && postProps.idx === postProps.postNum ? (
        <div className="post-img">
          <FontAwesomeIcon icon={faXmark} onClick={closeImgBtn} />
          <img src={imgBase64} />
        </div>
      ) : null}
    </form>
  );
}

export default WriteLastComment;
